<div stack-layout [fullHeight]="true" gap="md" paddingVertical="md">
  <div box-layout paddingHorizontal="md">
    <button
      text-button
      size="md"
      symbolLeft="chevron_left"
      variant="ghost"
      [routerLink]="['/orders']"
    >
      Order History
    </button>
  </div>
  @if (order) {
    <div center-layout paddingHorizontal="lg">
      <div
        grid-layout
        gap="md"
        [templateAreas]="gridLayout()"
        [fullWidth]="true"
      >
        <div
          box-layout
          gridArea="heading"
          elevation="raised"
          borderRadius="xs"
          padding="sm"
          color="secondary-surface"
          border="medium"
        >
          <div
            row-layout
            justifyContent="space-between"
            alignItems="center"
            paddingHorizontal="sm"
          >
            <div row-layout alignItems="center" gap="sm">
              <div>
                <Text role="headline-large" color="on-background-variant">
                  Order No.
                </Text>
                <Text role="title-large" color="on-background-variant">{{
                  order.orderNumber
                }}</Text>
              </div>
              @if (permissionToManageOrders()) {
                <app-download-button
                  mode="text"
                  label="Download Logs"
                  [blobObservable]="downloadErpLogs(order.orderId)"
                  [downloadFileName]="getErpLogDownloadFilename(order.orderId)"
                  [preserveFileExtension]="true"
                  [preferFileNameFromHeader]="true"
                />
              }
            </div>

            <div row-layout alignItems="center" gap="md">
              <Text role="headline-small"> Status : </Text>
              <div
                box-layout
                borderRadius="max"
                border="medium"
                [style.background-color]="getStatusColor(order.status)"
              >
                <!-- TODO: Update to use permission based regions.  Hard-coding region checks is not allowed. -->
                @if (isMexicoRegion()) {
                  <Menu [menuItems]="menuItems()">
                    <button
                      text-button
                      variant="ghost"
                      size="md"
                      symbolRight="arrow_drop_down"
                    >
                      {{ statusLabel() }}
                    </button>
                  </Menu>
                } @else {
                  <div box-layout paddingHorizontal="md" paddingVertical="xs">
                    <Text display="block">{{
                      getStatusLabel(order.status)
                    }}</Text>
                  </div>
                }
              </div>
            </div>
          </div>
        </div>

        <div
          box-layout
          gridArea="order"
          color="primary-surface"
          paddingVertical="md"
          paddingHorizontal="md"
          borderRadius="xs"
          border="medium"
          elevation="raised"
        >
          <div
            row-layout
            alignItems="center"
            justifyContent="space-between"
            wrapItems="wrap"
          >
            <div row-layout gap="md" alignItems="center" paddingRight="md">
              <div row-layout gap="xs">
                <Symbol name="article" />
                <Text role="headline-medium" color="on-background-variant">
                  Order Details
                </Text>
              </div>
              <Text color="on-tertiary-container-variant" display="block">{{
                order.orderDate | date: 'MM/dd/yyyy HH:mm:ss'
              }}</Text>
            </div>

            @if (order.promptForSync && permissionToManageOrders()) {
              <div row-layout alignItems="center" justifyContent="right">
                <Text color="on-warn-container" display="block" role="label">
                  Failed to send to WMS...
                </Text>
                <Text color="on-primary-surface-variant">
                  <button
                    text-button
                    size="md"
                    variant="ghost"
                    (click)="syncOrder(order.orderId)"
                    [loading]="syncingOrder()"
                  >
                    Sync
                  </button>
                </Text>
              </div>
            }
          </div>

          <div row-layout [fullWidth]="true" gap="lg" paddingVertical="md">
            @if (order) {
              <div grid-layout templateColumns="1fr 1fr" gap="lg" [grow]="1">
                <div stack-layout>
                  <Text role="headline-small"> Order Number </Text>
                  <Text>{{ order.orderNumber }}</Text>
                </div>

                <div stack-layout>
                  <Text role="headline-small"> Sales Type </Text>
                  <Text>{{ order.salesType }}</Text>
                </div>

                <div stack-layout>
                  <Text role="headline-small"> Buyer Name </Text>
                  <Text>{{ order.buyerName }}</Text>
                </div>

                <div stack-layout>
                  <Text role="headline-small"> Buyer Company Name </Text>
                  <Text>{{ order.buyerCompanyNumber }}</Text>
                </div>

                <div stack-layout>
                  <Text role="headline-small"> Login Email </Text>
                  <Text>{{ order.buyerEmail }}</Text>
                </div>

                <div stack-layout>
                  <Text role="headline-small"> DCC </Text>
                  <Text>
                    {{ order.dccCode }}
                    @if (order.dcc) {
                      ({{ order.dcc.name }})
                    }
                  </Text>
                </div>

                <div stack-layout>
                  <Text role="headline-small"> Warehouse </Text>
                  <Text>
                    {{ order.warehouseCode }}
                    @if (order.warehouse) {
                      ({{ order.warehouse.name }})
                    }
                  </Text>
                </div>

                <div stack-layout>
                  <Text role="headline-small"> Currency Code </Text>
                  <Text>{{ order.currencyCode }}</Text>
                </div>

                <div stack-layout>
                  <Text role="headline-small"> WMS Order Number </Text>
                  <Text>{{ order.erpOrderNumber }}</Text>
                </div>

                <div stack-layout>
                  <Text role="headline-small"> WMS Sync Date </Text>
                  <Text>{{ order.syncDate | date }}</Text>
                </div>

                <div stack-layout>
                  <Text role="headline-small"> PO Number </Text>
                  <Text>
                    <Text>{{ order.purchaseOrderNumber }}</Text>
                  </Text>
                </div>

                <div stack-layout>
                  <Text role="headline-small"> Pre Order </Text>
                  <Text>
                    <Text>{{ order.preOrderDate ? 'Yes' : 'No' }}</Text>
                  </Text>
                </div>

                <div stack-layout>
                  <Text role="headline-small"> Fulfillment Date </Text>
                  <Text>
                    <Text>{{
                      order.preOrderDate | date: 'MM/dd/yyyy HH:mm:ss'
                    }}</Text>
                  </Text>
                </div>
              </div>
            }
            <div>
              <div
                box-layout
                color="primary-container"
                borderRadius="xs"
                paddingVertical="md"
                paddingHorizontal="lg"
              >
                <Text color="on-background-variant">
                  <div stack-layout gap="md">
                    <Text display="block" role="headline-medium" align="center">
                      Order Total
                    </Text>
                    <div row-layout justifyContent="space-between" gap="md">
                      <Text display="block"> Order Raw Total </Text>
                      <Text display="block">
                        {{ formatOrderTotalAmount(order.itemCost, order.currencyCode) }}</Text
                      >
                    </div>
                    <div row-layout justifyContent="space-between" gap="md">
                      <Text display="block"> Shipping Charges </Text>
                      <Text display="block">
                        {{ formatOrderTotalAmount(order.shippingCost, order.currencyCode) }}</Text
                      >
                    </div>
                    <div row-layout justifyContent="space-between" gap="md">
                      <Text display="block"> Tax </Text>
                      <Text display="block">
                        {{ formatOrderTotalAmount(order.taxCost, order.currencyCode) }}</Text
                      >
                    </div>
                    <div row-layout justifyContent="space-between" gap="md">
                      <Text display="block" role="headline-small">
                        Order Total
                      </Text>
                      <Text display="block" role="headline-small">
                        {{ formatOrderTotalAmount(order.totalCost, order.currencyCode) }}</Text
                      >
                    </div>
                    <div row-layout justifyContent="space-between" gap="md">
                      <Text display="block" role="headline-small">
                        Total Quantity
                      </Text>
                      <Text display="block" role="headline-small">
                        {{ order.totalQty }}</Text
                      >
                    </div>
                  </div>
                </Text>
              </div>
            </div>
          </div>
        </div>

        <!-- <div
          stack-layout
          gap="sm"
          gridArea="billing"
          color="primary-surface"
          paddingVertical="md"
          paddingHorizontal="lg"
          borderRadius="xs"
          border="medium"
          elevation="raised"
        >
          <Text role="headline-medium"> Quick Links </Text>
          <div>
            <Text display="block"> Download Order Details</Text>
            <Text display="block"> Download Invoice</Text>
          </div>
        </div> -->

        <div
          stack-layout
          gap="md"
          gridArea="shipping"
          color="primary-surface"
          paddingVertical="md"
          paddingHorizontal="md"
          borderRadius="xs"
          border="medium"
          elevation="raised"
        >
          <Text role="headline-medium" color="on-background-variant">
            Order Information
          </Text>

          <div row-layout alignItems="start" gap="sm">
            <oui-symbol name="receipt_long" [opticalSize]="20" />
            <div stack-layout gap="xs">
              <Text role="headline-small" color="on-background-variant">
                Billing
              </Text>
              <div>
                <Text display="block">
                  {{ order.billingAddress.firstName }}
                  {{ order.billingAddress.lastName }}</Text
                >
                <Text display="block">
                  {{ order.billingAddress.address1 }}
                  {{ order.billingAddress.address2 }}</Text
                >
                <Text display="block">
                  {{ order.billingAddress.city }},
                  {{ order.billingAddress.state }}
                  {{ order.billingAddress.postalCode }}
                </Text>
              </div>
            </div>
          </div>

          <div row-layout alignItems="start" gap="sm">
            <oui-symbol name="local_shipping" [opticalSize]="20" />
            <div stack-layout gap="xs">
              <Text role="headline-small" color="on-background-variant">
                Shipping
              </Text>
              <Text display="block">
                {{ order.shippingAddress.firstName }}
                {{ order.shippingAddress.lastName }}
              </Text>
              <Text display="block">
                {{ order.shippingAddress.address1 }}
                {{ order.shippingAddress.address2 }}
              </Text>
              <Text display="block">
                {{ order.shippingAddress.city }},
                {{ order.shippingAddress.state }}
                {{ order.shippingAddress.postalCode }}
              </Text>
            </div>
          </div>

          <div row-layout alignItems="start" gap="sm">
            <div box-layout [width]="20"></div>
            <div stack-layout gap="xs">
              <Text
                role="headline-small"
                display="block"
                color="on-background-variant"
              >
                Method
              </Text>
              <Text>
                {{ order.shippingMethod }}
              </Text>
            </div>
          </div>

          <div row-layout alignItems="start" gap="sm">
            <div box-layout [width]="20"></div>
            <div stack-layout gap="xs">
              <Text
                role="headline-small"
                display="block"
                color="on-background-variant"
              >
                Customer No.
              </Text>
              <Text>
                {{ order.shippingCustomerNumber }}
              </Text>
            </div>
          </div>

          <div row-layout alignItems="start" gap="sm">
            <div box-layout [width]="20"></div>
            <div stack-layout gap="xs">
              <Text
                role="headline-small"
                display="block"
                color="on-background-variant"
              >
                Carrier
              </Text>
              <Text>
                {{ order.shippingCarrier }}
              </Text>
            </div>
          </div>
        </div>

        @if (hasBulkShipping()) {
          <div
            stack-layout
            gap="sm"
            gridArea="bulkShipping"
            color="primary-surface"
            paddingVertical="md"
            paddingHorizontal="lg"
            borderRadius="xs"
            border="medium"
            elevation="raised"
          >
            <Text role="headline-medium"> Bulk Shipping Info </Text>
            <div>
              <Text role="headline-small" display="block"> Method </Text>
              <Text>
                {{ order.bulkShippingMethod }}
              </Text>
            </div>

            <div>
              <Text role="headline-small" display="block"> Customer No. </Text>
              <Text>
                {{ order.bulkShippingCustomerNumber }}
              </Text>
            </div>

            <div>
              <Text role="headline-small" display="block"> Carrier </Text>
              <Text>
                {{ order.bulkShippingCarrier }}
              </Text>
            </div>
          </div>
        }

        <div box-layout gridArea="products">
          @if (orderItems) {
            <DataTable
              [datasource]="orderItems"
              [columns]="orderItemColumns"
              [useRowClick]="false"
            >
              <div
                box-layout
                ngProjectAs="data-table-header"
                alignItems="center"
                paddingHorizontal="sm"
                paddingTop="xs"
              >
                <div row-layout gap="xs">
                  <Symbol name="article" />
                  <Text role="headline-medium" color="on-background-variant">
                    Order Items
                  </Text>
                </div>
              </div>
            </DataTable>
          }
        </div>

        <div row-layout justifyContent="end" padding="md">
          <div row-layout justifyContent="space-between" gap="md">
            <button text-button size="md" (click)="cancelStatusUpdate()">
              Cancel
            </button>
            <!-- TODO: Update to use permission based regions.  Hard-coding region checks is not allowed. -->
            @if (isMexicoRegion()) {
              <button
                text-button
                size="md"
                (click)="updateOrderStatusId(order.orderId)"
              >
                Save
              </button>
            }
          </div>
        </div>
        <div
          stack-layout
          gridArea="pricing"
          color="primary-surface"
          paddingVertical="sm"
          paddingHorizontal="md"
          borderRadius="xs"
          border="medium"
          elevation="raised"
          gap="sm"
        >
          <Text role="headline-medium" color="on-background-variant">
            Order Notes
          </Text>
          <Text>{{ order.notes }}</Text>
        </div>
      </div>
    </div>
  }
</div>
